












import Vue from "vue";

export default Vue.extend({
  name: "SearchMenu",
  props: [
    "placeholder",
  ],
  data() {
    return {
      menuShowing: false
    };
  },
  methods: {
    onClick() {
      this.menuShowing = !this.menuShowing;
    },
    hideSearchMenu(e: any) {
      if(e.relatedTarget == null) {
        this.menuShowing = false;
      }
    }
  }
});
